import * as React from 'react';
import { FilespaceStorage } from 'fs-api-client';
import { formatDataSize } from '../../../utils/utilFunctions';
import { CircledExclamationMarkIcon } from '../Icons';

export interface Timestamp {
    days: number;
    hours: number;
    minutes: number;
}

interface FileSpaceCardInfo {
    provider: FilespaceStorage.ProviderEnum;
    region?: string;
    expiryDate?: Timestamp;
    filespaceSize?: number;
    usedStorage?: number;
    isLegacySandboxStyle?: boolean;
    connectedDevices?: number;
}

export default function FileSpaceCardTitleInfo(props: FileSpaceCardInfo): JSX.Element | null {
    let providerRegion = props.region ?
            '(' + props.region + ')' :
            null,
        filespaceSize = typeof props.filespaceSize === 'number' ?
            (
                <React.Fragment>
                    <li className={`capacity${props.isLegacySandboxStyle ? '-blue' : ''}`}>
                        <span>
                            File system size
                            <span className="ttip">
                                <div>File system size represents the total usage of your live data as measured by your computer’s operating system. Live data is what you see when you open the Filespace on a desktop level.</div>
                                <CircledExclamationMarkIcon className="info blue" width="12" height="12" />
                            </span>
                        </span>
                        {props.filespaceSize ? formatDataSize(props.filespaceSize) : '0 GB'}
                    </li>
                </React.Fragment>
            ) :
            null,
        usedStorage = typeof props.usedStorage === 'number'  ?
            (
                <React.Fragment>
                    <li className={`capacity${props.isLegacySandboxStyle ? '-blue' : ''}`}>
                        <span>
                            Used storage
                            <span className="ttip">
                                <div>Used storage represents the total amount of data in your object storage bucket. This encompasses your live data, plus any additional data used for snapshots, plus any data selected for deletion but not yet fully purged.</div>
                                <CircledExclamationMarkIcon className="info blue" width="12" height="12" />
                            </span>
                        </span>
                        {props.usedStorage ? formatDataSize(props.usedStorage) : '0 GB'}
                    </li>
                </React.Fragment>
            ) :
            null,

        expiryDate = props.expiryDate ?
            (
                <li className="right">
                    <span>Expires after</span>
                    {props.expiryDate.days}d {props.expiryDate.hours}h {props.expiryDate.minutes}m
                </li>
            ) :
            null;
    return (
        <ul className="settings">
            <li>
                <span>Provider</span>
                {props.provider} {providerRegion}
            </li>
            {filespaceSize}
            {usedStorage}
            {expiryDate}
        </ul>
    );
}



// WEBPACK FOOTER //
// ./src/webportal/components/common/filespaceCardComponents/FilespaceCardInfoSection.tsx